import React from 'react';
import { Separator } from './ui/separator';
import { Heart, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="py-12 bg-background" data-testid="site-footer">
      <div className="section-container">
        <Separator className="mb-8" />
        
        <div className="text-center space-y-4">
          <p className="text-lg font-serif text-foreground flex items-center justify-center gap-2">
            Thank you for celebrating with us
            <Heart className="w-4 h-4 text-primary fill-primary" />
          </p>
          
          <div className="flex items-center justify-center gap-2 text-sm text-muted-foreground">
            <MapPin className="w-4 h-4 text-primary" />
            <span>Sherwood Farms</span>
          </div>
          
          <p className="text-sm text-muted-foreground">
            <a 
              href="https://www.sherwoodfarm.com.au/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-primary hover:underline"
            >
              Visit Sherwood Farms
            </a>
          </p>

          <Separator className="my-6 max-w-xs mx-auto" />
          
          <p className="text-xs text-muted-foreground">
            Robyn & Angelo • September 18-21, 2026
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;